import { render, staticRenderFns } from "./BrowsingHistoryProducts.vue?vue&type=template&id=6f6df9a1&scoped=true&"
import script from "./BrowsingHistoryProducts.vue?vue&type=script&lang=js&"
export * from "./BrowsingHistoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./BrowsingHistoryProducts.vue?vue&type=style&index=0&id=6f6df9a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6df9a1",
  null
  
)

export default component.exports